import { ExtendedShapeValue } from 'src/atoms/true-trade-area/visitors-origin'
import { AMCensusBlockValue } from 'src/common-services'

export const visitsToVisitsShape = (visits: AMCensusBlockValue[]): ExtendedShapeValue[] => {
  const totalVisits = visits.reduce((acc, visit) => acc + visit.value, 0)
  return visits.map((visit) => {
    return {
      ...visit,
      percentTotal: visit.value / totalVisits,
      difference: 0,
      differencePercentage: 0,
      countyState: '',
    } as ExtendedShapeValue
  })
}
